import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../services/api';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';
import { toMask } from '../../services/currency';
import ServicesFilter, { ServiceFilterFields } from './ServicesFilter';
import {
  getLastFilterByKey,
  upsertFilterToKey,
} from '../../services/filterService';

type ServiceModel = {
  id: number;
  name: string;
  price: number;
};

export default function ServicesIndex() {
  const pageKey = 'services';
  const [isLoading, setIsLoading] = useState(true);
  const [Services, setServices] = useState([] as ServiceModel[]);
  const [filterFields, setFilterFields] = useState<ServiceFilterFields>(
    null as unknown as ServiceFilterFields
  );
  const {
    user: { organization },
  } = useAuth();

  async function getServices(data: ServiceFilterFields) {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/services`,
        { params: data }
      );
      setServices(response.data.data);
      setIsLoading(false);
    }
  }

  const onFilterSubmit = (data: ServiceFilterFields) => {
    const filter = new ServiceFilterFields(data);
    upsertFilterToKey(pageKey, filter);
    setFilterFields(filter);
    getServices(data);
  };

  const remove = useCallback(
    async (service: ServiceModel) => {
      try {
        const displayName = `${service.name}`;
        if (
          // eslint-disable-next-line no-restricted-globals
          confirm(
            `Você tem certeza que deseja remover o serviço "${displayName}"? Essa ação não poderá ser desfeita.`
          )
        ) {
          await api.delete(
            `organizations/${organization.id}/services/${service.id}`
          );
          console.log(pageKey);

          const filters = getLastFilterByKey(pageKey, ServiceFilterFields);
          getServices(filters);
          toast.success(`O serviço "${displayName}" foi removido`);
        }
      } catch (e) {
        toast.error(
          'Houve um problema ao tentar remover o serviço. Tente novamente.'
        );
      }
    },
    [organization.id, getServices, getLastFilterByKey, toast]
  );

  useEffect(() => {
    if (organization) {
      const filters = getLastFilterByKey(pageKey, ServiceFilterFields);
      setFilterFields(filters);
      getServices(filters);
    }
  }, [organization]);

  return (
    <List
      isLoading={isLoading}
      title='Serviços'
      newItemUrl='new'
      filter={
        <ServicesFilter filterFields={filterFields} onSubmit={onFilterSubmit} />
      }
    >
      <table className='table table-hover'>
        <thead>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Nome</th>
            <th scope='col' className='text-end'>
              Preço
            </th>
            <th scope='col'>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {Services.map((i) => {
            return (
              <tr key={i.id}>
                <th scope='row'>{i.id}</th>
                <td>
                  <Link to={`${i.id}/edit`}>{i.name}</Link>
                </td>
                <td className='text-end'>{toMask(i.price)}</td>
                <td className='text-end'>
                  <button
                    className='btn btn-sm btn-danger'
                    type='button'
                    onClick={() => remove(i)}
                  >
                    <FaTimes />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </List>
  );
}
